/** Response latency past which a reply reads as slow, in seconds. */
const SLOW_RESPONSE_SECONDS = 3
/** Response latency past which a reply reads as very slow, in seconds. */
const VERY_SLOW_RESPONSE_SECONDS = 5

export type ResponseLatencySeverity = "normal" | "slow" | "very-slow"

/**
 * How slow a response was. The transcript chip and the waveform region for the
 * same gap both read it, so the two never disagree about a gap.
 */
export function getResponseLatencySeverity(
  seconds: number,
): ResponseLatencySeverity {
  if (seconds > VERY_SLOW_RESPONSE_SECONDS) {
    return "very-slow"
  }
  if (seconds > SLOW_RESPONSE_SECONDS) {
    return "slow"
  }
  return "normal"
}
